import React, { useCallback, useState } from 'react';
import debounce from 'lodash/debounce';
import { Input } from '@progress/kendo-react-inputs';
import { searchLineItems } from 'src/fetch/inventoryUnit';
import LoadingSpinner from 'shared/loading/LoadingSpinner';

const LineItemsLookup = (props) => {
    const [isLoading, setIsLoading] = useState(null);

    const retrieveOrder = useCallback(debounce(async (number) => {

        if (number) {
            setIsLoading(true);
            const lineItems = await searchLineItems({ type: props.type, number: number });
            props.setLineItems(lineItems);
            props.setNeedReload(true);
            props.setAddedFrom(number);
            setIsLoading(false);
        }
    }, 500), []);

    const handleChange = (event) => {
        retrieveOrder(event.value);
    };

    return (
        <>
            <div style={{ display: 'inline-flex', alignItems: 'center', minWidth: '30%' }}>
                <Input onChange={handleChange} label={props.label} />
            </div>
            <br />

            {isLoading && (
                <LoadingSpinner text={'Searching for line items...'} />
            )}
        </>
    );
};

export default LineItemsLookup;